import { assocPath, clone, dissocPath, isEmpty, isNil, path, pathOr } from 'ramda';
import {
	CLEAR_DONORS,
	CLEAR_DONOR_UPDATE_ERRORS,
	GET_DONOR,
	GET_DONORS,
	FETCH_DONOR_FAILED,
	FETCH_DONORS_FAILED,
	FETCH_DONOR_SUCCEEDED,
	FETCH_DONORS_SUCCEEDED,
	UPDATE_DONOR,
	UPDATE_DONOR_FAILED,
	UPDATE_DONOR_SUCCEEDED,
	CREATE_NEW_ASSIGNMENT_FAILED,
	CREATE_NEW_ASSIGNMENT_SUCCEEDED,
	UPDATE_ASSIGNMENT_SUCCEEDED,
	UPDATE_FILTER,
	SET_SORT_BY,
} from './donor.constant';
import { donorsInitialState } from './donor.initialState';
import { UPDATE_FUNDRAISER_SUCCEEDED } from '../fundraisers/fundraiser.action';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

const clearErrorState = (state, errorType) => ({
	...state,
	[errorType]: null,
});

export const donorReducer = (state = donorsInitialState, action) => {
	switch (action.type) {
		case CLEAR_DONORS: {
			return {
				...state,
				entities: donorsInitialState.entities,
				isDirty: false,
				totalToDisplay: 0,
				skip: 0,
			};
		}

		case CLEAR_DONOR_UPDATE_ERRORS: {
			return clearErrorState(state, 'updateError');
		}

		case GET_DONOR: {
			return createPendingState(state, 'pendingFetch');
		}

		case GET_DONORS: {
			return createPendingState(state, 'pendingFetch');
		}

		case FETCH_DONOR_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case FETCH_DONORS_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case FETCH_DONOR_SUCCEEDED: {
			const fetchedDonorId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingFetch: false,
			};
			if (fetchedDonorId) {
				newState.entities = {
					...state.entities,
					[fetchedDonorId]: action.payload,
				};
			}

			return newState;
		}

		case FETCH_DONORS_SUCCEEDED: {
			const newTotal = path(['payload', 'total'], action);
			const newSkip =
				newTotal >= state.skip ? { skip: action.payload && action.payload.skip + 10 } : {};

			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			return {
				...state,
				entities,
				pendingFetch: false,
				isDirty: false,
				totalToDisplay: newTotal,
				...newSkip,
			};
		}

		case UPDATE_DONOR: {
			return createPendingState(state, 'pendingUpdate');
		}

		case CREATE_NEW_ASSIGNMENT_FAILED:
		case UPDATE_DONOR_FAILED: {
			return createErrorState(state, 'pendingUpdate', 'updateError', action.payload);
		}

		case UPDATE_ASSIGNMENT_SUCCEEDED:
		case CREATE_NEW_ASSIGNMENT_SUCCEEDED: {
			const { donor } = action.payload;
			const newState = {
				...state,
				entities: {
					...state.entities,
					[donor._id]: {
						...state.entities[donor._id],
						fundraisers: donor.fundraisers,
					},
				},
				pendingUpdate: false,
			};

			return newState;
		}

		case UPDATE_FUNDRAISER_SUCCEEDED: {
			const updatedDonorId = path(['payload', '_id'], action);
			const newState = {
				...state,
			};

			if (updatedDonorId && newState.entities.hasOwnProperty(updatedDonorId)) {
				newState.entities = {
					...state.entities,
					[updatedDonorId]: action.payload,
				};
			}

			return newState;
		}

		case UPDATE_DONOR_SUCCEEDED: {
			const updatedDonorId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedDonorId) {
				newState.entities = {
					...state.entities,
					[updatedDonorId]: action.payload,
				};
			}

			return newState;
		}

		case UPDATE_FILTER: {
			// If there is no filters selected, remove the path to avoid sending empty values to the server
			if (isNil(action.payload.value) || isEmpty(action.payload.value)) {
				return dissocPath(['filters', action.payload.filterKey], state);
			}
			return assocPath(['filters', action.payload.filterKey], action.payload.value, state);
		}

		case SET_SORT_BY: {
			return {
				...state,
				sortBy: action.payload.sortValue,
			};
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/donors/donor.reducer.js